/*
* A light-weight implementation for easy route parameters
* https://github.com/egoist/path-extract
* */

/*
*
  Usage

     var pathExtract = require('path-extract')

     pathExtract('/user/:username/post/:id', '/user/egoist/post/1')
     //=> params:
     {
         username: 'egoist',
         id: '1'
     }

     pathExtract('/user/*', '/user/egoist/post/1')
     //=> params:
     {
         '*': 'egoist/post/1'
     }

     pathExtract('/user/:id', '/list/foo')
     //=> null
* */
module.exports = function extract(pattern, pathname) {
    var names = [];

    var re = new RegExp(
        pattern
            .replace(/:([\w]+)/g, function(m, p1){
                names.push(p1);
                return '([^\\/]+)'
            })
            .replace(/(\*)/g, function(m, p1){
                names.push(p1);
                return '([^$]*)'
            })
        , 'g');

    if (names.length === 0) {
        return null
    }

    var matches = re.exec(pathname);
    if (!matches) {
        return null
    }

    var params = {};
    for (var i = 0; i < names.length; i++) {
        params[names[i]] = matches[i + 1]
    }

    return params
};


//////////////////
// WEBPACK FOOTER
// ./src/core/path-extract.js
// module id = 83
// module chunks = 0